import { Box, BoxProps, Text } from "@chakra-ui/react";

export const Footer = (props: BoxProps) => (
  <Box {...props}>
    <Text textAlign={"center"}>
      Copyright &copy; {new Date().getFullYear()} Illuma Technology
    </Text>
  </Box>
);
